import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import DataTable from '../DataTable';
import ItemList from '../Form/ItemList';

@inject('parameterStore')
@observer
class ParameterList extends Component {
  render() {
    const { parameterStore, children } = this.props;

    return (
      <div>
        <ItemList
          store={parameterStore}
          columns={[
            { key: 'id', label: 'ID' },
            { key: 'parameter_type_id', label: 'Parameter Type ID' },
            { key: 'code', label: 'Code' },
            { key: 'name', label: 'Name' },
            { key: 'description', label: 'Description' },
          ]}
          slug={'/parameter'}
          resource='parameter'
          children={children}
          allowAdd={false}
          allowEdit={false}
          allowDelete
        />
      </div>

    );
  }
}

export default ParameterList;



// WEBPACK FOOTER //
// ./src/components/Parameter/ParameterList.js